// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__M5_Ff","cartGroup":"Links_cartGroup__KSctM","qty":"Links_qty__12nF7"};